import { ILeadsResponse } from "../types/open-demat-button-types.types";
import { API_PATHS } from "../constants/api-paths";
import { encryptedRequest } from "../core/api.client";

export const leadsBuySell = async (payload: string) => {
  const response: ILeadsResponse = await encryptedRequest({
    method: "POST",
    url: API_PATHS.leads,
    data: {
      mobileNo: payload,
    },
  });
  return response;
};
